<template>
  <div class="floor3-wrapper">
    <img src="https://img.gegejia.com/img/14df74b613ad9521cff1570fb21a0344.png" class="w" alt="">
    <img src="https://img.gegejia.com/img/bb3b0f78fe7555ee141ef5f3bfbfea94.png" class="w"alt="">
    <div class="swiper-content">
      <swiper ref="mySwiper1" :options="swiperOption" class="show-swiper">
        <template v-for="(item, index) in list">
          <swiper-slide :key="index">
            <div class="swiper-item">
              <img :src="item" alt="">
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-button-prev swiper-button-gray" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-gray2" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>

  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import("swiper/dist/css/swiper.css");
  export default {
    data() {
      var that = this
      return {
        list: [
          'https://img.gegejia.com/img/a534ffc9fd1c165f20a37fa38d808179.png',
          'https://img.gegejia.com/img/1af781810e9012fe3a406e9575ef8bd9.png',
          'https://img.gegejia.com/img/bcdab9ba2e10169c22cb6a11e92c9bb5.png',
          'https://img.gegejia.com/img/b23ed764621d6e15ca633d8f1eaf6301.png',
          'https://img.gegejia.com/img/e31b96cbc27429ca106746e533b3cd27.png',
          'https://img.gegejia.com/img/cc125ad84b67a94791b22f7f9bfa45ea.png',
          'https://img.gegejia.com/img/8cd87ee08bdebb5337b2842bd6f7c9c5.png',
        ],
        activeIndex: 1,
        swiperOption: {
          // 设置slider容器能够同时显示的slides数量，默认为1， 'auto'则自动根据slides的宽度来设定数量
          slidesPerView: 'auto',
          initialSlide:2,
          spaceBetween: 0,
          /*
          * 开启这个参数来计算每个slide的progress(进度、进程)
          * 对于slide的progress属性，活动的那个为0，其他的依次减1
          */
          watchSlidesProgress: true,
          // 默认active slide居左，设置为true后居中
          centeredSlides: true,
          // 当你创建一个Swiper实例时是否立即初始化，这里我们手动初始化
          init: true,
          longSwipesRatio: 0.1,
          touchReleaseOnEdges: true,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          on: {
            progress: function() {
              for (let i = 0; i < this.slides.length; i++) {
                const slide = this.slides.eq(i) // 指定匹配元素集缩减值
                const slideProgress = this.slides[i].progress // 当前元素集的progress值

                let modify = 0 // 偏移权重
                if (parseInt(Math.abs(slideProgress)) > 0) {
                  modify = Math.abs(slideProgress) * 0.9 // 不一定要0.2，可自行调整
                }
                const translate = slideProgress * modify * 100 + 'px' // 500是swiper-slide的宽度
                const scale = 1 - Math.abs(slideProgress) / 5 // 缩放权重值，随着progress由中向两边依次递减，可自行调整
                const zIndex = 99 - Math.abs(Math.round(10 * slideProgress))
                slide.transform(`translateX(${translate}) scale(${scale})`)
                slide.css('zIndex', zIndex)
                slide.css('opacity', 1) // 是否可见
                if (parseInt(Math.abs(slideProgress)) > 3) { // 设置了只有选中的元素以及他两遍的显示，其他隐藏
                  slide.css('opacity', 0)
                }
              }
            },
            slideChange: function() {
              that.activeIndex = this.activeIndex
            }
          },
          pagination: {
            el: '.swiper-pagination',
            bulletActiveClass: 'my-bullet-active',
//            bulletClass : 'my-bullet',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    components: {
      swiper,
      swiperSlide,
    },
  }
</script>

<style scoped lang="less">
.floor3-wrapper{
  width: 100%;
  height: 100%;
  .w{
    width: 100%;
  }
}
.swiper-content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  padding: 50px 0 120px;

  .show-swiper {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .swiper-slide {
      width: 518px;
      width: auto;
      border-radius: 16px;
      overflow: hidden;
      // 表示所有属性都有动作效果，过度时间为0.4s，以慢速开始和结束的过渡效果
      transition: all .4s cubic-bezier(.4, 0, .2, 1);

      .swiper-item img{
        width: 100%;
        height: 776px;
        background: rgb(140, 172, 134);
        border-radius: 16px;
        overflow: hidden;
      }
    }
  }
}
  .swiper-button-gray{
    background: url('https://img.gegejia.com/img/3261467f7c58babf088ae673412ccae6.png') no-repeat  !important;
    background-size: contain !important;
  }
  .swiper-button-gray2{
    background: url('https://img.gegejia.com/img/51b27ea0c3bf73a6dcff268af1c4bd42.png') no-repeat  !important;
    background-size: contain !important;
  }
  .my-bullet-active{
    background: #fff !important;
  }
  .my-bullet{
    background: #000 !important;
  }
  .swiper-pagination{
    bottom: -50px !important;
  }
  .swiper-container{
    overflow: visible !important;
  }
</style>




// WEBPACK FOOTER //
// src/views/t97/block/floor_3.vue